import locationsMap from './locations-map';

const resultsSelector = '#projects-listing-results';
const itemsSelector = '#projects-listing-items';
const paginationSelector = '#projects-listing-pagination';
const mapRootSelector = '[data-comp-name="locations-map"]';

function reloadMap() {
    const mapRootNode = document.querySelector(mapRootSelector);
    const locations = JSON.parse(mapRootNode.dataset.compParams);

    locationsMap(
        mapRootNode,
        locations,
    );
}

export default function ProjectsListing(el) {
    const filtersForm = el.querySelector('.projects-listing__form');
    const filters = el.querySelector('.projects-listing__filters');
    const filterButtons = filters.querySelectorAll('.projects-listing__filter-button');
    const filterToggles = el.querySelectorAll('[data-filter-toggle]');
    const checkboxes = filters.querySelectorAll('input[type="checkbox"]:not([data-filter-toggle] input)');
    const clearAllBtns = el.querySelectorAll('.projects-listing__clear-filters');
    const selectAllBtns = filters.querySelectorAll('label[for*="select-all"]');
    const mapToggleBtn = el.querySelector('[data-map-toggle]');
    const mapContainer = el.querySelector('.projects-listing__map');
    const chipsContainer = el.querySelector('.projects-listing__chips');
    const loadingOverlay = el.querySelector('.loader-wrapper');

    if (mapToggleBtn) {
        mapToggleBtn.addEventListener('click', e => {
            e.target.closest('[data-map-toggle]').classList.toggle('active');
            mapContainer.classList.toggle('active');
        });
    }

    filterToggles.forEach(button => {
        button.addEventListener('click', e => {
            const toggle = e.target.closest('[data-filter-toggle]');
            toggle.classList.toggle('active');

            const input = toggle.querySelector('input');
            if (input) {
                // input.value = toggle.classList.contains('active') ? 1 : 0;
                input.checked = toggle.classList.contains('active');
            }

            filtersForm.dispatchEvent(new Event('change'));
        });
    });

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.classList.contains('active')) {
                button.classList.remove('active');
                button.nextElementSibling.classList.remove('active');
            } else {
                filterButtons.forEach(btn => {
                    btn.classList.remove('active');
                    btn.nextElementSibling.classList.remove('active');
                });
                button.classList.add('active');
                button.nextElementSibling.classList.add('active');
            }
        });
    });

    clearAllBtns.forEach(clearAllBtn => {
        clearAllBtn.addEventListener('click', () => {
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });

            filterToggles.forEach(button => {
                button.classList.remove('active');
                const input = button.querySelector('input');
                input.checked = false;
            });

            filtersForm.dispatchEvent(new Event('change'));
        });
    });

    selectAllBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            const parentList = e.target.closest('.projects-listing__filters-options');
            const groupCheckboxes = parentList.querySelectorAll('input[type="checkbox"]');
            groupCheckboxes.forEach(checkbox => {
                if (e.target.previousElementSibling.checked === false) {
                    checkbox.checked = true;
                } else {
                    checkbox.checked = false;
                }
            });
            filtersForm.dispatchEvent(new Event('change'));
        });
    });

    const createChip = (value, text) => {
        if (
            ['all-locations'].includes(value)
            || value.includes('select-all')
        ) {
            return;
        }

        const li = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('data-value', value);
        button.textContent = text;
        li.appendChild(button);
        li.setAttribute('data-value', value);
        chipsContainer.appendChild(li);
    };

    const removeChip = value => {
        chipsContainer.removeChild(chipsContainer.querySelector(`li[data-value="${value}"]`));
    };

    chipsContainer.addEventListener('click', e => {
        if (e.target.tagName === 'BUTTON' && e.target.hasAttribute('data-value')) {
            const value = e.target.getAttribute('data-value');
            const checkbox = filters.querySelector(`input[type="checkbox"][value="${value}"]`);
            checkbox.checked = false;
            filtersForm.dispatchEvent(new Event('change'));
        }
    });

    async function updateCards(url) {
        loadingOverlay.classList.add('active');

        const response = await fetch(url);
        const htmlString = await response.text();
        const htmlNode = document.createElement('html');
        htmlNode.innerHTML = htmlString;

        const resultsNode = htmlNode.querySelector(resultsSelector);
        const itemsNode = htmlNode.querySelector(itemsSelector);
        const paginationNode = htmlNode.querySelector(paginationSelector);
        const mapRootNode = htmlNode.querySelector(mapRootSelector);

        document.querySelector(resultsSelector).innerHTML = resultsNode.innerHTML;
        document.querySelector(itemsSelector).innerHTML = itemsNode.innerHTML;
        document.querySelector(paginationSelector).innerHTML = paginationNode.innerHTML;
        document.querySelector(mapRootSelector)
            .setAttribute('data-comp-params', mapRootNode.dataset.compParams);

        reloadMap();

        loadingOverlay.classList.remove('active');
    }

    function updateChips() {
        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                if (!chipsContainer.querySelector(`li[data-value="${checkbox.value}"]`)) {
                    createChip(checkbox.value, checkbox.nextElementSibling.innerText);
                }
            } else if (chipsContainer.querySelector(`li[data-value="${checkbox.value}"]`)) {
                removeChip(checkbox.value);
            }
        });
    }

    function updateCount() {
        let filterCountNode;
        filterButtons.forEach(button => {
            switch (button.dataset.filterButton) {
            case 'dropdown':
                filterCountNode = button.querySelector('[data-filter-count]');
                if (filterCountNode) {
                    const numItemsChecked = button.parentElement.querySelectorAll('input[name]:checked').length;
                    filterCountNode.innerText = numItemsChecked > 0 ? `(${numItemsChecked})` : '';
                }
                break;
            default:
            }
        });
    }

    function updateToggles() {
        filterToggles.forEach(button => {
            const input = button.querySelector('input');
            if (input.checked) {
                button.classList.add('active');
            }
        });
    }

    filtersForm.addEventListener('change', () => {
        updateChips();
        updateCount();

        const formData = new FormData(filtersForm);
        const params = new URLSearchParams(formData);
        const url = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, '', url);

        updateCards(url);
    });

    window.addEventListener('popstate', () => {
        // Parse URL params
        const params = new URLSearchParams(window.location.search);

        // Update checkboxes based on params
        checkboxes.forEach(checkbox => {
            const { name } = checkbox;
            const { value } = checkbox;
            const paramValues = params.getAll(name);
            checkbox.checked = paramValues.includes(value);
        });

        // Update chips UI
        checkboxes.forEach(checkbox => {
            if (checkbox.value.includes('select-all')) return;
            if (checkbox.checked) {
                if (!chipsContainer.querySelector(`li[data-value="${checkbox.value}"]`)) {
                    createChip(checkbox.value, checkbox.nextElementSibling.innerText);
                }
            } else if (chipsContainer.querySelector(`li[data-value="${checkbox.value}"]`)) {
                removeChip(checkbox.value);
            }
        });

        // Update cards
        updateCards(window.location.href);
    });

    // load chips on page load if query params
    updateChips();
    updateCount();
    updateToggles();
}
